export default __webpack_public_path__ + "static/media/img_background_slide_two.e569f597.png";